import * as React from 'react';
import { SVGProps } from 'react';

const IconMapFilledSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="m2 3 2-.667v7L2 10V3ZM5 9V2l2 1v7L5 9ZM8 9.667 10 9V2l-2 .667v7Z" />
  </svg>
);
export default IconMapFilledSizeXs;
